import { createSlice } from '@reduxjs/toolkit';
import { ILocation } from 'shared/types/location';

export const regionsSlice = createSlice({
  name: 'regions',
  initialState: [] as ILocation[],
  reducers: {},
});

export const { reducer: regionsReducer, name: regionsReducerName } = regionsSlice;
